export const RATNA_WARNING_TYPES = {
  TWENTY_FIVE_PERCENT_CONSUMPTION: 'TWENTY_FIVE_PERCENT_CONSUMPTION',
  FIFTY_PERCENT_CONSUMPTION: 'FIFTY_PERCENT_CONSUMPTION',
  ONE_HUNDRED_PERCENT_CONSUMPTION: 'ONE_HUNDRED_PERCENT_CONSUMPTION',
};
